import gql from "graphql-tag"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import CustomRewardFragment from "./CustomReward"
import RecognitionFragment from "@irati/recognition/apollo/fragments/Recognition"

const fragment = gql`
  fragment CustomRewardTransaction on CustomRewardTransaction {
    uuid
    receiverId
    dateUnix
    adminId
    isUsed
    recognitionId
    receiver {
      ...partialUser
    }
    author {
      ...partialUser
    }
    recognition {
      ...Recognition
    }
    customReward {
      ...CustomReward
    }
    metadata {
      createdAt
    }
  }
  ${partialUser}
  ${CustomRewardFragment}
  ${RecognitionFragment}
`

export default fragment
